// Small shared constants + label helpers for the Processos module.
// Kept local so the module stays fully isolated.
export const PROCESS_STATUSES = [
  { value: "open",        label: "Aberto" },
  { value: "in_progress", label: "Em andamento" },
  { value: "waiting",     label: "Aguardando" },
  { value: "on_hold",     label: "Em espera" },
  { value: "completed",   label: "Concluído" },
  { value: "cancelled",   label: "Cancelado" },
];

export const PROCESS_PRIORITIES = [
  { value: "low",     label: "Baixa" },
  { value: "medium",  label: "Média" },
  { value: "high",    label: "Alta" },
  { value: "urgent",  label: "Urgente" },
];

export const STATUS_STYLES = {
  open:        { dot: "bg-slate-400",  bg: "bg-slate-100 text-slate-700 border-slate-200" },
  in_progress: { dot: "bg-sky-500",    bg: "bg-sky-50 text-sky-700 border-sky-200" },
  waiting:     { dot: "bg-amber-500",  bg: "bg-amber-50 text-amber-700 border-amber-200" },
  on_hold:     { dot: "bg-zinc-500",   bg: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  completed:   { dot: "bg-emerald-500",bg: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled:   { dot: "bg-rose-500",   bg: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const PRIORITY_STYLES = {
  low:    { bg: "bg-slate-100 text-slate-700 border-slate-200" },
  medium: { bg: "bg-blue-50 text-blue-700 border-blue-200" },
  high:   { bg: "bg-orange-50 text-orange-700 border-orange-200" },
  urgent: { bg: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const statusLabel = (v) => PROCESS_STATUSES.find((s) => s.value === v)?.label || v || "—";
export const priorityLabel = (v) => PROCESS_PRIORITIES.find((p) => p.value === v)?.label || v || "—";

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
